// extracted by mini-css-extract-plugin
export default {"container":"FileUploader_container__0Me0G","drag-over":"FileUploader_drag-over__ZRo2X","text":"FileUploader_text__1g+Ks","subtext":"FileUploader_subtext__20sZq"};